const { PLACEMENT_UI_GROUPS: UI_GROUPS } = require('./constants');

const DirectRenderConditionFields = [
	{
		type: 'String',
		description: 'Action',
		name: 'action',
		hasOptions: true,
		isRequired: true,
		defaultValue: 'direct',
		options: [
			{ name: 'direct', label: 'Render bid directly without ad-request' },
			{ name: 'bypass', label: 'Exclude from ad request, but render directly as fallback.' },
			{ name: 'drop', label: 'Exclude bid completely' },
		],
	},
	{
		type: 'Number',
		name: 'cpm',
		description: 'Minimum CPM',
		omitWhenDefault: true,
	},
	{
		type: 'String',
		name: 'dealId',
		description: 'Deal ID',
		props: {
			help: 'Comma separate in order to use multiple deal ids',
		},
		omitWhenDefault: true,
	},
	{
		type: 'String',
		name: 'sspIds',
		description: 'Bidder',
		optionType: 'BaseSsp',
		multiSelect: true,
		omitWhenDefault: true,
	},
];

const FieldSettings = {
	type: 'Object',
	uiGroup: UI_GROUPS.BUILT_IN,
	name: 'rlvDirectRender',
	description: 'Direct rendering and bid exclusion settings for Prebid.js',
	fields: [
		{
			type: 'Boolean',
			name: 'enabled',
			description: 'Enable direct rendering/exclusion of Prebid.js bids matching conditions',
			props: {
				help: 'Notice: rules defined by Slot.defineSizeMapping() in gpt.js and GAM Lazy Load settings will have no effect on directly rendered bids.',
			},
		},
		...DirectRenderConditionFields,
		{
			type: 'Array',
			description: 'Other matching conditions (OR)',
			name: 'otherConds',
			fields: DirectRenderConditionFields,
			omitWhenDefault: true,
		},
	],
};

module.exports = { FieldSettings };
